/**
 *  ------------------------------------
 *  Imports
 *  ------------------------------------
 */
import { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import useMaintenanceBypass from 'hooks/useMaintenanceBypass';
import MaintenanceContext from 'contexts/MaintenanceContext';
import { stripTestPrefix } from 'services/testMode';

/**
 *  ------------------------------------
 *  TestModeRoute Component
 *  ------------------------------------
 */
const TestModeRoute: FunctionComponent = () => {

    const [, setMaintenanceBypass] = useMaintenanceBypass();
    const maintenanceData: any = useContext(MaintenanceContext);
    const location = useLocation();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!maintenanceData.loaded) {
            return;
        }
        if (maintenanceData.isInsel) {
            setMaintenanceBypass(true);
        }
        setReady(true);
        // eslint-disable-next-line
    }, [maintenanceData.loaded, maintenanceData.isInsel]);

    if (!ready) {
        return null;
    }

    // The maintenance API's ip didn't resolve to the Insel network (161.62.0.0/16)
    // — send the visitor to the normal, non-/test counterpart of this URL instead
    // of letting them stay on the test mirror.
    if (!maintenanceData.isInsel) {
        return <Navigate to={{ pathname: stripTestPrefix(location.pathname), search: location.search }} replace />;
    }

    return <Outlet />;
}

/**
 *  ------------------------------------
 *  Exports
 *  ------------------------------------
 */
export default TestModeRoute;
